import axios from '@/plugins/axios'

export default {
  fetchForMe: function (params) {
    return axios.get('/inventory-items-issued/me', { params: params })
      .then(response => response.data)
  }
}
